// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_style_text__1Teqj","placeholder":"Text_style_placeholder__3MR9Q","main":"Text_style_main__56s2b"};